import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import img1 from "../assets/home.jpg"
import img2 from "../assets/home2.jpg"


const images = [img1, img2];
const Home = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 6000); 

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full min-h-screen flex flex-col justify-center items-center overflow-hidden">
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${images[index]})` }}
          initial={{ x: "100%", opacity: 0 }}
          animate={{ x: "0%", opacity: 1 }}
          exit={{ x: "-100%", opacity: 0 }}
          transition={{ duration: 1, ease: "easeInOut" }}
        />
      </AnimatePresence>
      <div className="relative z-10 ">
        <h1 className="text-6xl font-extrabold text-center text-white mb-4">
          Velkominn á Viking Knives
        </h1>
        <p className="text-xl text-gray-200 mb-8">
          Veldu þjónustu
        </p>
        <div className="flex gap-4">
          <Link
            to="/laser-engraving"
            className="lightShadow bg-transparent text-white border-2 border-white py-2 px-6 rounded-full text-lg font-semibold hover:border-2 hover:text-white hover:shadow-lg transform hover:scale-110 transition duration-300"
          >
            Laser Merkingar
          </Link>
          <Link
            to="/knives"
            className="lightShadow bg-transparent text-white border-2 border-white py-2 px-10 rounded-full text-lg font-semibold hover:text-white hover:shadow-lg transform hover:scale-110 transition duration-300"
          >
            Hnífar
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;